/**
 * Runtime device / browser hints for deferring work without changing layout or visuals.
 */

export function isSafari() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|EdgiOS/i.test(ua);
}

export function isAppleDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const platform = navigator.platform || '';
  return (
    /Mac|iPhone|iPad|iPod/i.test(platform) ||
    /Macintosh|iPhone|iPad/i.test(ua) ||
    (navigator.userAgentData?.platform && /macOS|iOS/i.test(navigator.userAgentData.platform))
  );
}

/** Cap canvas backing-store scale — Retina MacBooks often use DPR 2+ and melt the GPU. */
export function getCanvasDevicePixelRatio(max = 2) {
  if (typeof window === 'undefined') return 1;
  const raw = window.devicePixelRatio || 1;
  const isMobile = window.matchMedia('(max-width: 768px), (pointer: coarse)').matches;
  const cap = isMobile ? Math.min(max, 1.75) : max;
  return Math.min(raw, cap);
}

export function prefersReducedMotion() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function isLowEndDevice() {
  if (typeof navigator === 'undefined') return false;
  const cores = navigator.hardwareConcurrency || 8;
  const memory = navigator.deviceMemory || 8;
  return cores <= 4 || memory < 4;
}

/** Fewer globe surface dots on constrained devices — visually similar at hero scale. */
export function getGlobeDotCount(defaultCount = 700) {
  if (isLowEndDevice() || (isAppleDevice() && isSafari())) return Math.round(defaultCount * 0.72);
  return defaultCount;
}

export function isDocumentVisible() {
  if (typeof document === 'undefined') return true;
  return document.visibilityState !== 'hidden';
}
